import { eventMenuItemClicked } from './cam-context-switcher-constants';
import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import CamContextSwitcherMenuItem from './cam-context-switcher-menu-item';

const tagName = 'cam-context-switcher-menu-list';
const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherMenuItemList extends HTMLElement {

  static get observedAttributes() {
    return [ 'selected-menu-item' ];
  }

  constructor() {
    super();
    this.datastore = camContextSwitcherDatastore;
  }

  connectedCallback() {
    this.classList.add(tagName);

    this.addEventListener(eventMenuItemClicked, this.handleMenuItemChange);

    this.innerHTML = template(this.dataset);
    this.container = this.querySelector('.menu-content');
  }

  renderMenuItemList(menuItemList) {
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }

    let selected = false;

    if(this.dataset.type === 'costcenter'){
      selected = !this.datastore.selectedCostcenter;
    } else if(this.dataset.type === 'organization'){
      selected = !this.datastore.selectedOrganization;
    }

    let allMenuItems = {
      context: {
        id: null,
        type: this.dataset.type
      },
      display: {
        title: `All (${menuItemList.length})`,
        selected: selected
      }
    };
    let menuItemElement = new CamContextSwitcherMenuItem(allMenuItems);
    this.container.appendChild(menuItemElement);
    menuItemList.forEach((item) => {
      menuItemElement = new CamContextSwitcherMenuItem(item);
      this.container.appendChild(menuItemElement);
    });
  }

}

if (!customElements.get(tagName)) {
  customElements.define(tagName, CamContextSwitcherMenuItemList);
}



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-menu-list.js